import { useEffect, useRef, useState } from "react";

export default function usePostList(loadPosts, refreshVersion = 0) {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const loaded = useRef(false);
  useEffect(() => {
    let active = true;
    let fetching = false;
    const refresh = async () => {
      if (fetching) return;
      fetching = true;
      try {
        const response = await loadPosts();
        if (active) setPosts(response.posts);
      } catch (error) {
        console.error("Não foi possível atualizar as publicações:", error);
      } finally {
        fetching = false;
        if (active) { loaded.current = true; setIsLoading(false); }
      }
    };
    if (!loaded.current) setIsLoading(true);
    refresh();
    const refreshVisible = () => { if (document.visibilityState === "visible") refresh(); };
    const timer = window.setInterval(refreshVisible, 30000);
    window.addEventListener("focus", refreshVisible);
    document.addEventListener("visibilitychange", refreshVisible);
    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener("focus", refreshVisible);
      document.removeEventListener("visibilitychange", refreshVisible);
    };
  }, [loadPosts, refreshVersion]);
  return { posts, isLoading, setPosts };
}
